var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 105,
    viewBox: "0 0 116 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8742 82.3205L21.2094 90.8651C20.2901 91.3664 19.464 91.9825 18.6953 92.6541C27.8283 100.355 39.618 105.001 52.4994 105.001C65.2856 105.001 77 100.424 86.1073 92.8284C85.2673 92.1192 84.356 91.4813 83.3456 90.9781L66.5713 82.5919C64.404 81.5082 63.035 79.2933 63.035 76.8704V70.2891C63.5065 69.7522 64.0454 69.0628 64.6219 68.2485C66.9081 65.0193 68.6377 61.4671 69.8362 57.7406C71.9878 57.0769 73.5727 55.0899 73.5727 52.7283V45.7033C73.5727 44.158 72.8852 42.7771 71.8174 41.8103V31.655C71.8174 31.655 73.9035 15.8516 52.5013 15.8516C31.0992 15.8516 33.1853 31.655 33.1853 31.655V41.8103C32.1155 42.7771 31.43 44.158 31.43 45.7033V52.7283C31.43 54.5787 32.4028 56.2072 33.8589 57.1483C35.6142 64.7895 40.2104 70.2891 40.2104 70.2891V76.708C40.2084 79.0457 38.9286 81.1992 36.8742 82.3205Z",
    fill: "#E7ECED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3973 0.00781787C24.4074 -0.487465 0.503106 22.6125 0.00782304 51.6024C-0.273498 68.0399 7.05273 82.8132 18.7176 92.6376C19.4804 91.972 20.2986 91.3618 21.2079 90.8665L36.8727 82.3219C38.9272 81.2006 40.207 79.0471 40.207 76.7054V70.2865C40.207 70.2865 35.6088 64.7869 33.8555 57.1456C32.4013 56.2046 31.4266 54.5781 31.4266 52.7257V45.7006C31.4266 44.1554 32.114 42.7745 33.1819 41.8077V31.6524C33.1819 31.6524 31.0957 15.8489 52.4979 15.8489C73.9001 15.8489 71.814 31.6524 71.814 31.6524V41.8077C72.8838 42.7745 73.5692 44.1554 73.5692 45.7006V52.7257C73.5692 55.0872 71.9843 57.0743 69.8328 57.738C68.6342 61.4645 66.9047 65.0167 64.6185 68.2459C64.042 69.0602 63.5031 69.7496 63.0316 70.2865V76.8678C63.0316 79.2907 64.4006 81.5076 66.5679 82.5893L83.3422 90.9755C84.3486 91.4787 85.2579 92.1146 86.0959 92.8219C97.4082 83.3877 104.717 69.2821 104.988 53.3973C105.487 24.4074 82.3892 0.503101 53.3973 0.00781787Z",
    fill: "#556080"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 25.5,
    r: 9.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5004 24.4309C93.6346 24.4309 92.9329 25.1488 92.9329 26.034C92.9329 26.9194 93.6346 27.6371 94.5004 27.6371C95.366 27.6371 96.0679 26.9194 96.0679 26.034C96.0679 25.1488 95.366 24.4309 94.5004 24.4309ZM98.6804 22.8277H97.4264C97.254 22.8277 97.0682 22.6909 97.0137 22.5236L96.6896 21.5287C96.6349 21.3614 96.4493 21.2246 96.2769 21.2246H92.7239C92.5515 21.2246 92.3657 21.3614 92.3112 21.5288L91.9871 22.5237C91.9324 22.6909 91.7468 22.8277 91.5744 22.8277H90.3204C89.7456 22.8277 89.2754 23.3087 89.2754 23.8965V28.7059C89.2754 29.2937 89.7456 29.7746 90.3204 29.7746H98.6804C99.2551 29.7746 99.7254 29.2937 99.7254 28.7059V23.8965C99.7254 23.3087 99.2551 22.8277 98.6804 22.8277ZM94.5004 28.7059C93.0576 28.7059 91.8879 27.5096 91.8879 26.034C91.8879 24.5585 93.0576 23.3621 94.5004 23.3621C95.943 23.3621 97.1129 24.5585 97.1129 26.034C97.1129 27.5096 95.943 28.7059 94.5004 28.7059ZM98.3146 24.6439C98.1127 24.6439 97.9489 24.4765 97.9489 24.2698C97.9489 24.0633 98.1127 23.8957 98.3146 23.8957C98.5167 23.8957 98.6804 24.0633 98.6804 24.2698C98.6804 24.4765 98.5166 24.6439 98.3146 24.6439Z",
    fill: "#556080"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 67,
    y: 4,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoTemplate);
export default __webpack_public_path__ + "static/media/photo-template.f9d5aa399785e4d52d893b623343165f.svg";
export { ForwardRef as ReactComponent };